<div action="" class="css-radio-button-container">
  <label class="css-radio-button">
    <input type="checkbox" [(ngModel)]="value.checked" [value]="value" (change)="onValueChange($event)" [disabled]="disabled"/>
    {{ value.label | translate }}
  </label>
</div>
